<script lang="ts">
  import SectionVirementDeliveryList from '@/generated/sections/SectionVirementDeliveryList.vue';
  import Delivery from '@/extend/classes/Delivery';
  import { DeliveryTypes } from '@/generated/classes/Delivery';
  import { ColumnFilter, ListChoix } from '@/generated/classes/ListData';
  import Button from '@/framework/base/classes/Button';
  import { storeDocument } from '@/generated/stores';
  import Files, { DownloadData } from '@/generated/classes/Files';
  import { getBlob } from '@/framework/files/helpers/FileTypes';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import { DateFormat, isValidDate } from "@/framework/base/helpers/DateFormat";
  import { isProduction } from "@/framework/base/helpers/Environment";
  import { defineComponent } from "vue";

  export default defineComponent({
    extends: SectionVirementDeliveryList,
    name: 'SectionVirementDeliveryListExtend',
    components: {},
    data () {
      return {
        progress: false,
        fileName: '',
        buttons: [] as Button[],
      };
    },
    computed: {
      pageLimit (): number {
        return 10;
      },
      canAdd (): boolean {
        return false;
      },
    },
    methods: {
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = DeliveryTypes.VIREMENT;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "dateDelivery";
          columnFilter.sortDescending = true;
          this.activeFilters.push(columnFilter);
        }
      },
      mdiDocument (delivery: Delivery): string {
        return 'fas fa-code';
      },
      getDocumentColor (delivery: Delivery): string {
        if (delivery.xmlLoaded) {
          return '#1D6F42'
        } else {
          return '#F40F02'
        }
      },
      hasDocument (delivery: Delivery): boolean {
        return true;
      },
      getLabel (name: string, item: number, obj: unknown): string {
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'ownerType') {
          res = ObjTypes[item];
        } else {
          const column = this.listConfig.find(a => a.name == name);
          if (column) {
            const choix = column.choix.find(a => a.value == item);
            if (choix) {
              res = choix.text;
            }
          }
        }
        if (isValidDate(res)) {
          res = new Date(res).toString()
        }
        return res;
      },
      displayDocument (delivery: Delivery): void {
        this.loading = true;
        this.fileName = DateFormat.toFileName(delivery.dateDelivery) + ' ' + DeliveryTypes[delivery.type] + ' ' + delivery.id + '.xml';
        const data = new DownloadData();
        data.service = 'Delivery';
        data.type.extension = 'xml';
        data.data = JSON.stringify(delivery);
        if (!this.actionProgress) {
          this.actionProgress = true;
          Files.download(data)
            .then((buffer) => {
              const blob = getBlob(buffer, data.type.extension);
              const file = window.URL.createObjectURL(blob);
              const docUrl = document.createElement('a');
              docUrl.setAttribute('href', file);
              docUrl.setAttribute('download', this.fileName);
              document.body.appendChild(docUrl);
              docUrl.click();
              this.actionProgress = false;
            }).catch(() => {
              this.actionProgress = false;
            });
        }
      },
      getActionColor(delivery: Delivery): string {
          if (delivery.datePayed == null) {
            return '#F40F02';
          } else {
            return '#1D6F42';
          }
      },
      mdiAction (delivery: Delivery): string {
        return 'fas fa-landmark';
      },
      hasAction (delivery: Delivery): boolean {
        return true;
      },
      execAction(delivery: Delivery): void {
        if (!isProduction() && delivery.datePayed == null) {
          this.actionProgress = true;
          Delivery.simuBank(delivery).then((res) => {
            delivery.bankId = res.bankId;
            this.actionProgress = false;
          }).catch(() => {
            this.actionProgress = false;
          });
        }
      },
    },
  });
</script>